<div class="mc-path-list-item-content">
  <span class="mc-path-list-item-marker mc-flex-shrink-0"></span>
  <mc-self-truncating-path [filePath]="path"></mc-self-truncating-path>
  <ng-container [ngTemplateOutlet]="listItemActionsDirective?.templateRef" [ngTemplateOutletContext]="{ $implicit: path }"></ng-container>
</div>

<ng-container *ngFor="let listItemLineDirective of listItemLineDirectives">
  <ng-container [ngTemplateOutlet]="listItemLineDirective.templateRef" [ngTemplateOutletContext]="{ $implicit: path }"></ng-container>
</ng-container>